import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-oauth-callback',
  standalone: true,
  templateUrl: './oauth-callback.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './oauth-callback.component.css',
})
export class OauthCallbackComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    // do things with return state or "oauth/me" if required
    void this.router.navigate(['/']);
  }
}
